import { Haptics, ImpactStyle } from '@capacitor/haptics';

/**
 * Kurze Rückmeldung beim Antippen einer Checklistenzeile.
 *
 * Sie ist abschaltbar (Einstellungen → „Haptisches Feedback") und schlägt bewusst nie fehl:
 * auf dem Rechner und auf Geräten ohne Taptic Engine passiert schlicht nichts, und das darf
 * den Tipp nicht aufhalten.
 */
export function tapFeedback(enabled: boolean): void {
  if (!enabled) return;
  void Haptics.impact({ style: ImpactStyle.Light }).catch(() => {
    /* kein haptisches Gerät — kein Grund für einen Fehler */
  });
}

/**
 * Das Signal, wenn die Stationszeit abgelaufen ist.
 *
 * ⚠️ **Ein Hinweis, keine Ansage.** Die Uhr beendet nichts — das tut der Prüfer am
 * Abgabeknopf. Das Klopfen sagt ihm nur, dass die Zeit um ist, während er den Prüfling
 * ansieht und nicht das iPad.
 *
 * ⚠️ **Nicht am Schalter „Haptisches Feedback".** Der gilt dem Tippen auf eine
 * Checklistenzeile — eine Bequemlichkeit. Dieses Signal ist keine.
 *
 * ⚠️ **Kein Ton.** Der WebView darf ohne Fingertipp keinen abspielen, und ein Ton, der je nach
 * Gerät kommt oder nicht, ist schlimmer als keiner. Der Raumgong bleibt Sache der Prüfungsleitung.
 */
export function zeitAbgelaufen(): void {
  void Haptics.impact({ style: ImpactStyle.Heavy }).catch(() => {
    /* kein haptisches Gerät — dann bleibt es bei der Null in der Kopfzeile */
  });
}

/**
 * Das Signal einer neuen Mitteilung der Prüfungsleitung (Relay `MESSAGE`).
 *
 * Nur Vibration, kein Ton (Entscheidung des Nutzers, 2026-10-07) — aus demselben Grund wie bei
 * `zeitAbgelaufen`, und ebenso nicht am Schalter „Haptisches Feedback".
 */
export function mitteilungEingegangen(): void {
  void Haptics.impact({ style: ImpactStyle.Heavy }).catch(() => {
    /* kein haptisches Gerät — dann bleibt es beim Dialog */
  });
}
